import { useFantasyDayStore } from '@/stores/fantasy/day'
import { useFantasyStore } from '@/stores/fantasy'
import { DOTA_GROUPS_ORDER } from '../constants'
import type { DayTeamGroup } from '../types'

export const useFantasyDayTeams = () => {
  const { t } = useI18n()
  const fantasyDayStore = useFantasyDayStore()
  const fantasyStore = useFantasyStore()

  const { isLocked, isCompleted, isParticipated, positions, slots } =
    storeToRefs(fantasyDayStore)
  const { game } = storeToRefs(fantasyStore)

  const items = computed(() =>
    positions.value.map(item => ({
      position: item,
      slot: slots.value.find(slot => slot.position === item.id)
    }))
  )

  // Группы используются у доты: main, middle, support. Между ними в UI добавляется отступ. Для CS такого нет
  const groups = computed(() => {
    if (game.value === 'cs') {
      return []
    }

    const result = positions.value.reduce<DayTeamGroup[]>(
      (groups, position) => {
        let group = groups.find(item => item.type_id === position.type_id)

        if (!group) {
          group = { type_id: position.type_id, positions: [] }
          groups.push(group)
        }

        group.positions.push({
          id: position.id,
          type_id: position.type_id,
          slot: slots.value.find(slot => slot.position === position.id)
        })

        return groups
      },
      []
    )

    return result.sort(
      (firstGroup, secondGroup) =>
        DOTA_GROUPS_ORDER.indexOf(firstGroup.type_id) -
        DOTA_GROUPS_ORDER.indexOf(secondGroup.type_id)
    )
  })

  const slotsCount = computed(() => slots.value.length)
  const positionsCount = computed(() => positions.value.length)

  const labelTexts = computed(() => {
    if (isCompleted.value) {
      return {
        main: '',
        additional: t('dayEnd')
      }
    }

    if (isLocked.value) {
      return {
        main: isParticipated.value ? t('rosterSelected') : '',
        additional: t('waitForComplete')
      }
    }

    return {
      main: t('choose'),
      additional: `${slotsCount.value} ${t('of', { total: positionsCount.value })}`
    }
  })

  return {
    items,
    groups,
    labelTexts
  }
}
